import React, { Fragment, FunctionComponent } from "react";
import RegistrationContainerV3 from "../../../containers/v3/RegistrationContainer";
import ScreenContainerV3 from "../../v3/screen-container/ScreenContainer";
import RegistrationComponentV3 from "../../v3/registration/Registration";
import RegistrationContainerV4 from "../../../containers/v4/RegistrationContainer";
import ScreenContainerV4 from "../screen-container/ScreenContainer";
import RegistrationComponentV4 from "./Register";
import { ComponentClass } from "react-redux";
// eslint-disable-next-line import/named
import { RouteComponentProps } from "react-router";

interface QueryParams {
    v4?: string;
}

interface RegisterSwapperProps {
    version: number;
    routerProps: RouteComponentProps<undefined, undefined, undefined, QueryParams>;
}

const RegisterSwapper: FunctionComponent<RegisterSwapperProps> = ({
    version,
    routerProps
}: RegisterSwapperProps) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let RegistrationComponent: ComponentClass<any>;

    if (version === 4) {
        RegistrationComponent = RegistrationContainerV4(ScreenContainerV4(RegistrationComponentV4));
    } else {
        RegistrationComponent = RegistrationContainerV3(ScreenContainerV3(RegistrationComponentV3));
    }

    return (
        <Fragment>
            <RegistrationComponent
                location={ routerProps.location }
            />
        </Fragment>
    );
};

export default RegisterSwapper;
